import { API } from "services/api";
import { ClienteAtual, DestinoFixo, EnderecoEmpresa } from "./cliente.types";

/**
 * GET /verClienteAtual
 */
export const getClienteAtual = async (): Promise<ClienteAtual> => {
  const { data } = await API.get<ClienteAtual>("/verClienteAtual");
  return data;
};

/**
 * PUT /atualizarDestinoFixo
 */
export const atualizarDestinoFixo = async (
  dados: DestinoFixo
): Promise<DestinoFixo> => {
  const { data } = await API.put<{ cliente: DestinoFixo }>(
    "/atualizarDestinoFixo",
    dados
  );
  return data.cliente;
};

/**
 * PUT /atualizarRemetenteFixo
 */
export const atualizarRemetenteFixo = async (
  remetenteFixoAtivo: boolean
): Promise<boolean> => {
  const { data } = await API.put<{ cliente: { remetenteFixoAtivo: boolean } }>(
    "/atualizarRemetenteFixo",
    { remetenteFixoAtivo }
  );
  return data.cliente.remetenteFixoAtivo;
};

/**
 * PUT /atualizarEnderecoEmpresa
 */
export const atualizarEnderecoEmpresa = async (
  dados: EnderecoEmpresa
): Promise<EnderecoEmpresa> => {
  const { data } = await API.put<{ cliente: EnderecoEmpresa }>(
    "/atualizarEnderecoEmpresa",
    dados
  );
  return data.cliente;
};
